import { render } from "./size-guide-tab.vue?vue&type=template&id=3d17d58e"
import script from "./size-guide-tab.vue?vue&type=script&lang=js"
export * from "./size-guide-tab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__